// packages/chatbot/src/hooks/controller/useAssistantState.ts

import { useMemo } from 'react';
import type { UIMessage } from '../../types';

export function useAssistantState(
  isLoading: boolean,
  messages: UIMessage[]
): 'idle' | 'thinking' | 'streaming' {
  return useMemo(() => {
    if (isLoading) return 'thinking';
    const last = messages.length > 0 ? (messages[messages.length - 1] as any) : null;
    if (last && last.type === 'assistant' && last.isStreaming) return 'streaming';
    return 'idle';
  }, [isLoading, messages]);
}